import axios from 'axios';
import { ApiResponse, GetReportResponse, zps_wp } from '../zps';
import { handleDownload } from '../../app/utils/script';

export type UserShift = {
  gid: number;
  entid: number;
  eid: number;
  sid: number;
  shift: number;
  user: {
    entid: number;
    name: string;
    uid: number;
  };
  dateTimeOpen: string;
  dateTimeClose: string;
  total?: {
    cid: number;
    total: number;
    paid: number;
    paidAP: number;
  };
};

export interface UserShiftsResponse extends ApiResponse {
  totalRows: number;
  list: UserShift[];
}

export interface FileResult extends ApiResponse {
  fileBytes: string;
  fileName: string;
  type: string;
}

export enum OrderBy {
  DEFAULT = 'default',
  DATE_DESC = 'date_desc'
}

export const fetchUserShiftsList = (
  controller: AbortController,
  entid: number,
  sid: number,
  eid: number,
  shift: number,
  offset: number,
  limit: number,
  totalRows: boolean,
  begin?: string,
  end?: string,
  uid?: number,
  orderBy?: OrderBy
): Promise<UserShiftsResponse> => {
  const url =
    `${zps_wp}/api/user/shift?entid=${entid}&sid=${sid}&eid=${eid}&shift=${shift}&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    `${begin ? `&begin=${begin}` : ''}` +
    `${end ? `&end=${end}` : ''}` +
    `${uid ? `&uid=${uid}` : ''}` +
    `${orderBy ? `&orderBy=${orderBy}` : ''}`;

  return axios.get<UserShiftsResponse>(url, { signal: controller.signal }).then(res => res.data);
};

export const fetchUserShiftsListXLS = (
  entid: number,
  sid: number,
  eid: number,
  shift: number,
  controller: AbortController,
  begin?: string,
  end?: string,
  uid?: number
) => {
  return axios
    .get(
      `${zps_wp}/api/user/shift/report/list?format=xls&entid=${entid}&sid=${sid}&eid=${eid}&shift=${shift}` +
        `${begin ? '&begin=' + begin : ''}` +
        `${end ? '&end=' + end : ''}` +
        `${uid ? '&uid=' + uid : ''}`,
      { signal: controller.signal }
    )
    .then(res => {
      handleDownload(res.data.report, res.data.name, res.data.mime);
      return res.data;
    })
    .catch(err => {
      throw err;
    });
};

export const fetchUserShiftReport = (
  eid: number,
  entid: number,
  uid: number,
  shift: number,
  controller: AbortController
): Promise<ApiResponse> => {
  return axios
    .get<GetReportResponse>(`${zps_wp}/api/user/shift/report?&eid=${eid}&entid=${entid}&uid=${uid}&shift=${shift}`, {
      signal: controller.signal
    })
    .then(res => {
      if (res.data?.statusOper?.code === 0 && res.data.report) {
        handleDownload(res.data.report, res.data.name, res.data.mime);
      }

      return res.data;
    });
};
